module.exports = __webpack_public_path__ + "static/media/picture8@2x.0671b426.png";